import { render } from "./JournalVoucherCreate.vue?vue&type=template&id=e1fa7066&scoped=true"
import script from "./JournalVoucherCreate.vue?vue&type=script&lang=js"
export * from "./JournalVoucherCreate.vue?vue&type=script&lang=js"

import "./JournalVoucherCreate.vue?vue&type=style&index=0&id=e1fa7066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fa7066"]])

export default __exports__